module.exports = __webpack_public_path__ + "images/minilogo.7c76ce0.png";